import React from 'react'
import noop from 'lodash/noop'
import map from 'lodash/map'
import reduce from 'lodash/reduce'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './video.css'
//import playIcon from '../../../img/youtube-play-icon.png'
import {initVideo} from './VideoWrapper'



//ADAPTED FROM v1. Could probably use some more optimization/trimming
export default class Video extends React.Component {
  container = null;
  componentDidMount() {
    this.setupPlayer()
  }

  componentDidUpdate() {
    this.setupPlayer()
  }

  setupPlayer() {
    if (this.props.content.id) {
      this.player = initVideo(
        this.container,
        this.props.lazyRender,
        this.props.onPlayerStateChange || noop
      )
    }
  }
  _durationStringToSeconds(duration) {
    // Pad time with zeros
    const padTime = time => {
      const timeParts = time.split(':').map(part => {
        if (part.length === 0) {
          return '00'
        } else if (part.length === 1) {
          return `0${ part }`
        } else {
          return part
        }
      })
      if (timeParts.length === 0) {
        return '00:00:00'
      } else if (timeParts.length === 1) {
        return `00:00${ timeParts }`
      } else if (timeParts.length === 2) {
        return `00:${ timeParts.join(':') }`
      } else {
        return timeParts.join(':')
      }
    }
    const padded = padTime(duration).split(':')
    const seconds = reduce(
      map(padded, (part) => parseInt(part, 10)),
      (result, value, key) => result += value * Math.pow(60, padded.length-1-key),
      0)
    return seconds
  }

  render() {
    let classNames = ['video-content', this.props.className]
    if (!this.props.content.id) {
      classNames = ['no-video-content', this.props.className]
      return (
        <div className={classNames.join(' ')}>
          <FontAwesomeIcon icon={['fa', 'video']} />
        </div>
      )
    }

    return (
      <div ref={node => this.container = node} className={classNames.join(' ')}>
        <div
          className='video-player'
          data-id={ this.props.content.id }
          data-start={ this._durationStringToSeconds(this.props.content.startTime) }
          data-end={ this._durationStringToSeconds(this.props.content.endTime) }
        >
          <div className='video-aspect-ratio-16-9'>
            <div className='YT-iframe' />
            <img
              className='YT-preview'
              src={ `https://img.youtube.com/vi/${this.props.content.id}/hqdefault.jpg` }
              alt=''
            />
            <div className='YT-play' />
          </div>
        </div>
        <div className='video-annotations'>
          {
            this.props.content.annotations.map(annotation => {
              return (
                <div
                  key={ annotation.time }
                  className='video-annotation'
                  data-time={ this._durationStringToSeconds(annotation.time) }
                >
                  <a href='#' className='video-annotation-clickable-time-label'>
                    { annotation.time }
                  </a>
                  { annotation.text }
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }
}
Video.defaultProps = {
  lazyRender: true,
  className: '',
}



// WEBPACK FOOTER //
// ./src/core/components/interactive-content-blocks/video/Video.js